export default __webpack_public_path__ + "static/featured-2d05a64150a5722f2fe9a90a0fbe72ab.png";